module.exports = __webpack_public_path__ + "img/phone.1b932c48.png";